let _paddle = null;

// Module-level callback slot — swapped before each Checkout.open() via Paddle.Update()
let _currentResolve = null;
let _currentOnComplete = null;

function globalEventCallback(event) {
  if (event.name === "checkout.completed") {
    if (_currentOnComplete) _currentOnComplete(event.data);
  }
  if (event.name === "checkout.closed") {
    if (_currentResolve) _currentResolve();
  }
}

function loadScript() {
  return new Promise((resolve, reject) => {
    if (window.Paddle) {
      resolve(window.Paddle);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.onload = () => resolve(window.Paddle);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

async function getInstance(clientToken, environment) {
  if (_paddle) return _paddle;
  const Paddle = await loadScript();
  if (environment !== "production") {
    Paddle.Environment.set("sandbox");
  }
  Paddle.Initialize({ token: clientToken, eventCallback: globalEventCallback });
  _paddle = Paddle;
  return _paddle;
}

/**
 * Open the Paddle checkout overlay and return a Promise that resolves
 * when the overlay is closed (checkout.closed event).
 *
 * onComplete is called when checkout.completed fires (payment submitted),
 * which may be before the user closes the success screen.
 */
export function openPaddleCheckout({ transactionId, clientToken, environment, onComplete }) {
  return new Promise(async (resolve) => {
    const paddle = await getInstance(clientToken, environment);

    _currentResolve = resolve;
    _currentOnComplete = onComplete ?? null;

    // Update the global eventCallback in case Paddle was already initialized
    paddle.Update({ eventCallback: globalEventCallback });

    paddle.Checkout.open({
      transactionId,
      settings: {
        displayMode: "overlay",
        theme: "light",
      },
    });
  });
}
